export const EMPTY_CONNECTION_ENTRY_META_PER_TERMINAL_GROUP = {
  L1: { externalPropertyId: undefined, externalPropertyIdSource: undefined },
  L2: { externalPropertyId: undefined, externalPropertyIdSource: undefined },
  L3: { externalPropertyId: undefined, externalPropertyIdSource: undefined },
};

/**
 * To store additional details of the terminal name entry object.
 * Exclude the 'name' attribute, which is still recorded in the project.connections.L1/L2/L3 field directly.
 */
export const emptyConnectionEntryMeta = () =>
  Array.from(
    { length: 5 },
    () => EMPTY_CONNECTION_ENTRY_META_PER_TERMINAL_GROUP
  );

/**
 * Merge the data from project.connections and project.connectionEntryMeta to form the API payload.
 *
 * @param {Array} connections - The connections array from the project.connections field.
 * @example [
    { type: "", L1: "", L2: "", L3: "" },
    { type: "", L1: "", L2: "", L3: "" },
    { type: "", L1: "", L2: "", L3: "" },
    { type: "", L1: "", L2: "", L3: "" },
    { type: "", L1: "", L2: "", L3: "" },
  ]
 * @param {Array} connectionEntryMeta - The connectionEntryMeta array from the project.connectionEntryMeta field.
 * @example [
    {
      L1: { externalPropertyId: undefined, externalPropertyIdSource: undefined },
      L2: { externalPropertyId: undefined, externalPropertyIdSource: undefined },
      L3: { externalPropertyId: undefined, externalPropertyIdSource: undefined },
    },
    ... (5 row total)
  ]
 * @returns {Array} The payload to use in the API request.
 * @example [
    {
      type: "",
      L1: { name: "", externalPropertyId: null, externalPropertyIdSource: null },
      L2: { name: "", externalPropertyId: null, externalPropertyIdSource: null },
      L3: { name: "", externalPropertyId: null, externalPropertyIdSource: null },
    },
    ... (5 row total)
  ]
 */
export const toApiConnectionsValue = (
  connections = [],
  connectionEntryMeta = []
) =>
  (Array.isArray(connections) ? connections : []).map(
    (connection = {}, index) => {
      const meta = connectionEntryMeta[index] || {};

      const payload = {
        type: connection.type,
        L1: {
          name: connection.L1,
          ...omitIfUndefined("externalPropertyId", meta.L1?.externalPropertyId),
          ...omitIfUndefined(
            "externalPropertyIdSource",
            meta.L1?.externalPropertyIdSource
          ),
        },
        L2: {
          name: connection.L2,
          ...omitIfUndefined("externalPropertyId", meta.L2?.externalPropertyId),
          ...omitIfUndefined(
            "externalPropertyIdSource",
            meta.L2?.externalPropertyIdSource
          ),
        },
        L3: {
          name: connection.L3,
          ...omitIfUndefined("externalPropertyId", meta.L3?.externalPropertyId),
          ...omitIfUndefined(
            "externalPropertyIdSource",
            meta.L3?.externalPropertyIdSource
          ),
        },
      };

      return payload;
    }
  );

const omitIfUndefined = (fieldName, value) => {
  return value !== undefined ? { [fieldName]: value } : {};
};
